import { h } from '@stencil/core';

const Icon = ({ width = '1rem', height = 'auto' }) => {
  return (
    <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <g fill="#559C56">
        <path d="M339.9 301.9v99.2c0 6.8-5.5 12.3-12.3 12.3H113.8c-6.8 0-12.3-5.5-12.3-12.3V187.4c0-6.8 5.5-12.3 12.3-12.3h145.9l48.8-47.7H113.8c-33.1 0-60 26.9-60 60v213.7c0 33.1 26.9 60 60 60h213.7c33.1 0 60-26.9 60-60V234.6l-47.6 67.3z" />
        <path d="M456.5 71.8 241.6 375.4c-2.4 3.5-6.5 5.5-10.8 5.5h-.3c-4.4-.2-8.5-2.4-10.8-6.1l-88.3-139.4c-3.3-5.2-2.5-11.9 1.8-16.3 4.4-4.4 11.2-5.1 16.3-1.8l73.5 46L436.5 54.9c4.9-4.8 12.6-5 17.8-.6 5.2 4.3 6.2 12 2.2 17.5z" />
      </g>
    </svg>
  );
};

export default Icon;
